import { render } from "./ChatImageComposer.vue?vue&type=template&id=0da6b3ed&scoped=true"
import script from "./ChatImageComposer.vue?vue&type=script&lang=js"
export * from "./ChatImageComposer.vue?vue&type=script&lang=js"

import "./ChatImageComposer.vue?vue&type=style&index=0&id=0da6b3ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da6b3ed"]])

export default __exports__